import Navbar from "@/pages/home/components/Navbar";
import HeroSection from "@/pages/home/components/HeroSection";
import StatsSection from "@/pages/home/components/StatsSection";
import ServicesSection from "@/pages/home/components/ServicesSection";
import CoursesSection from "@/pages/home/components/CoursesSection";
import CommunitySection from "@/pages/home/components/CommunitySection";
import FarmSection from "@/pages/home/components/FarmSection";
import DonationSection from "@/pages/home/components/DonationSection";
import AboutSection from "@/pages/home/components/AboutSection";
import TutorsSection from "@/pages/home/components/TutorsSection";
import TestimonialsSection from "@/pages/home/components/TestimonialsSection";
import BookingSection from "@/pages/home/components/BookingSection";
import Footer from "@/pages/home/components/Footer";
export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <HeroSection />
      <StatsSection />
      <ServicesSection />
      <CoursesSection />
      <CommunitySection />
      <FarmSection />
      <DonationSection />
      <AboutSection />
      <TutorsSection />
      <TestimonialsSection />
      <BookingSection />
      <Footer />
    </div>
  );
}
